import {
  SET_AMOUNT,
  UPDATE_AMOUNT,
  TYPE_PERCENT,
  ACTION_INCREASE,
  ACTION_DECREASE,
} from './constants';

export const getNewAmount = (initialAmount, updateAction) => {
  switch (updateAction.type) {
    case SET_AMOUNT:
      return updateAction.payload;

    case UPDATE_AMOUNT:
      const { updateValue, type, action } = updateAction.payload;
      if (initialAmount === null) {
        return null;
      }
      let amount = +initialAmount;
      let diff = +updateValue;
      if (type === TYPE_PERCENT) {
        diff = (diff / 100) * initialAmount;
      }

      switch (action) {
        case ACTION_INCREASE:
          amount += diff;
          break;
        case ACTION_DECREASE:
          amount -= diff;
      }
      return +amount.toFixed(2);
  }
};

export const validateAmount = (updateAction) => {
  switch (updateAction.type) {
    case SET_AMOUNT: {
      const { payload } = updateAction;
      if (!Number.isFinite(payload)) {
        return 'Amount is required';
      } else if (payload <= 0) {
        return 'Amount should be > 0';
      }
      return '';
    }
    case UPDATE_AMOUNT: {
      const { updateValue } = updateAction.payload;
      if (!Number.isFinite(updateValue)) {
        return 'Amount is required';
      } else if (updateValue <= 0) {
        return 'Amount should be > 0';
      }
      return '';
    }
    default:
      return '';
  }
};
